<template>
  <div id="visa">
    <div v-for="item in contacts">
      <div class="input-group mb-3">
        <input type="text"
               name="user[phones][]"
               class="form-control phone"
               v-mask="['(##) ####-####', '(##) #####-####']"
               v-model="item.contact"
               autocomplete="chrome-off"
               required>
        <div class="input-group-append">
          <span class="input-group-text">
            <a class="btn btn-light" @click="addInput" data-toggle="tooltip" data-placement="top"
               title="Adicionar outro contato">+</a>
            <a v-if="quantity_contacts > 1" class="btn btn-danger" data-toggle="tooltip"
               @click="deleteContact(item)"
               data-placement="top"
               title="Apagar contato cadastrado">
              <i class="fa fa-times"></i></a>
          </span>
        </div>
      </div>
    </div>

    <div class="previous"
         v-for="(applicant, counter) in applicants"
         v-bind:key="counter">
      <div class="form-group">
        <div class="input-group mb-3">
          <input type="text"
                 :name="'user[phones][' + (counter + contacts.length) + ']'"
                 v-model="applicant.phone"
                 class="form-control phone"
                 v-mask="['(##) ####-####', '(##) #####-####']"
                 :class="{ 'form-control-danger': hasErrors('user.phones.'+counter) }"
                 style="height: 51px;"
                 autocomplete="chrome-off"
                 required>
          <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">
                <a class="btn btn-light" @click="addInput" data-toggle="tooltip" data-placement="top"
                   title="Adicionar outro contato">+</a>
                <a v-if="quantity_contacts > 1" class="btn btn-danger" @click="deleteInput(counter)"
                   title="Cancelar cadastro de contato"><i class="fa fa-times"></i></a>
              </span>
          </div>
        </div>
        <div v-if="hasErrors('user.phones.'+counter)" class="form-control-feedback">
          Formato inválido de telefone.
        </div>
      </div>
    </div>
    <span v-if="quantity_contacts > 9" id="limit_reached">Limite máximo de contatos atingido.</span>
  </div>
</template>

<script>
import {mask} from 'vue-the-mask'

export default {
  name: 'dynamic-contacts-form',

  directives: {mask},

  props: {
    userId: Number,
    currentContacts: Array | Object,
    oldData: Array | Object,
    errors: Array | Object,
    previousPhone: Text | null,
    isCreatedForm: Boolean | null,
  },

  data() {
    return {
      applicants: [],
      contacts: [],
      quantity_contacts: null,
    }
  },

  mounted() {
    if (!!this.isCreatedForm) {
      this.setQuantityOfContacts();
    }

    if (this.setOldDataInInput()) {
      this.getContacts();
    }

    if (this.previousPhone && this.applicants[this.quantity_contacts - 1]) {
      this.applicants[this.quantity_contacts - 1].phone = this.previousPhone
    }
  },

  computed: {
    phoneMask() {
      return '(##) #####-#####';
    },
  },

  methods: {
    setOldDataInInput() {
      if (this.oldData !== null && this.oldData.length > 0) {
        for (let i = 0; i < this.oldData.length; i++) {
          let phone = this.oldData[i]
          this.applicants.push({
            phone: phone
          });
        }

        this.setQuantityOfContacts();

        return false;
      } else {
        return true;
      }
    },

    setQuantityOfContacts() {
      this.quantity_contacts = this.contacts.length + this.applicants.length;
      if (this.quantity_contacts <= 0) {
        this.applicants.push({
          phone: '',
        });
        this.quantity_contacts = 1;
      }
    },

    addInput() {
      if (this.quantity_contacts <= 9) {
        this.applicants.push({
          phone: '',
        });
        this.quantity_contacts++;
      }
    },

    deleteInput(counter) {
      if (this.quantity_contacts > 1) {
        this.applicants.splice(counter, 1);
        this.quantity_contacts--;
      }
    },

    getContacts() {
      if (!this.userId) {
        return;
      }

      axios.get(`/ajax/supplier/contacts/${this.userId}`).then((response) => {
        this.contacts = response.data.data;
        this.setQuantityOfContacts();
      });
    },

    deleteContact(contact) {
      this.$snotify.confirm("Confirmar exclusão do contato?", "Excluir Contato", {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        buttons: [
          {text: 'Sim', action: () => this.confirmDelete(contact), bold: false},
          {text: 'Não'},
        ]
      });
    },

    confirmDelete(contact) {
      axios.delete(`/ajax/supplier/contacts/${contact.id}/delete`).then((response) => {
        if (response.status === 200) {
          let i = this.contacts.indexOf(contact);
          this.contacts.splice(i, 1);
          this.$snotify.success("Contato excluído com sucesso!", "Excluído", {
            timeout: 5000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
          });
          this.quantity_contacts--;
          this.setQuantityOfContacts();
        } else {
          this.$snotify.error("Contato não excluído", "Ocorreu um erro durante a exclusão", {
            timeout: 5000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
          });
        }
      });
    },

    hasErrors(name) {
      return !!this.errors[name];
    },

    getErrorMessage(name) {
      return this.errorsBag[name].toString();
    }
  }
}
</script>

<style scoped>
#limit_reached {
  color: red;
}

.form-control-danger {
  border: 1px solid #FF0000 !important;
}

.form-control-feedback {
  font-size: 13px;
  color: red;
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/DynamicContactsForm.vue